var exports = {
  "LN": "rightContentWrapper__DE7XPN",
  "dU": "reducedTopPadding__I6AUlR",
  "I6": "constrainedHeader__3mxXgT",
  "z": "summary__0aq3YA",
  "N1": "headerContainer__8EHzEz",
  "Li": "titleWithAction__ouGvRe",
  "DD": "title__T_G_Mt",
  "gD": "sidePanelOpen__cL0CWW",
  "A2": "sidePanelOpenUpdatedHeader__GrA8Gi",
  "lj": "actionsAboveTitleOnNarrow__Q6VWPJ",
  "K1": "actionsAboveTitleOnNarrowContainer__3AMR5U",
  "Zn": "updatedActions___695D9",
  "Di": "editTitleFormUpdatedHeader___OLugN",
  "sI": "editTitleFormSidePanelOpen__QcJpH4",
  "Xn": "headerBorderBottom__EGA2X_",
  "Mi": "inlineTitle__2vo_uR",
  "QL": "titleSuffix__ZhvAF5",
  "$i": "inlineTitleSuffix__jFGp-G",
  "DP": "hideWhenVeryNarrowContainer__gKh_VK",
};

module.exports = exports;
